import { AxiosInstance } from 'axios'
import { createOptimizedAPI } from '../utils'

export interface IConnectorsWidgetStatus {
  muted: string | null;
}

export function connectorsWidgetApiFactory(api: AxiosInstance) {
  const baseUrl = '/web/api/v2/connectors-widget'
  const methods = {
    getConnectorsWidgetStatus() {
      return api.get<IConnectorsWidgetStatus>(baseUrl)
    },
    muteConnectorsWidget() {
      return api.post<IConnectorsWidgetStatus>(baseUrl)
    }
  }
  return createOptimizedAPI(methods)
}
